import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import ExportButton from 'pages/Investor/FinancialModel/ExportButton';
import Schedule from './Schedule';
import RecentActivity from './RecentActivity';
import RecentFeedback from './RecentFeedback';
import ChartFeedbackData from '../Feedbacks/charts/ChartFeedbackData';
import InvestorList from './InvestorList';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '70%',
    margin: '6rem auto'
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '16px'
  },
  sidebar: {
    flex: '0.3',
    marginTop: '39px'
  },
  searchBarContainer: {
    marginLeft: '20px',
    flex: '0.7'
  },
  resultsContainer: {
    width: '100%',
    marginTop: 40
  },
  resultsPaper: {
    padding: 15
  },
  resultsTitle: {
    fontWeight: 'bold',
    fontSize: 18,
    margin: '20px 0'
  },
  searchContainer: {
    margin: '10px 0',
    padding: 10
  },
  query: {
    margin: '5px 0',
    cursor: 'pointer'
  },
  exportButtonContainer: {
    margin: '20px 0',
    textAlign: 'right'
  }
}));

const Investors = () => {
  const classes = useStyles();
  const [option, setOption] = useState('');

  let output;

  switch (option) {
    case 'breakdown':
      output = <ChartFeedbackData />;
      break;
    case 'investorList':
      output = <InvestorList />;
      break;
    default:
      output = null;
  }

  const options = [
    {
      value: 'breakdown',
      label: 'Breakdown of feedback received by investor category'
    },
    { value: 'investorList', label: 'List of investors that have declined' }
  ];

  return (
    <div className={classes.container}>
      {/* Sidebar Components */}
      <div className={classes.sidebar}>
        <Schedule />
        <RecentActivity />
        <RecentFeedback />
      </div>
      {/* Main area -> Searchbar */}
      <div className={classes.searchBarContainer}>
        <h3 className={classes.title}>What information are you looking for?</h3>
        <Select
          onChange={(e) => setOption(e.value)}
          options={options}
          placeholder="Search..."
        />
        {output && (
          <div className={classes.resultsContainer}>
            <h5 className={classes.resultsTitle}>RESULTS</h5>
            {output}
            <div className={classes.exportButtonContainer}>
              <ExportButton />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(Investors);
